<ng-container *transloco="let t">
    <h1 class="text-center small-abstand-bottom">{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.PLANNING_TITLE') }}</h1>
    <h2 class="text-center big-abstand-bottom">{{ kinderOrt().getDisplayName() }} {{ range() }}</h2>
    <dvlib-spinner class="centered-spinner" [show]="isLoading()"></dvlib-spinner>

    @if (!isLoading() && violations().length === 0) {
        <p class="text-center">{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.PLANNING_NO_VIOLATIONS') }}</p>
    } @else {
        <div class="table-responsive">
            <table class="table">
                <caption class="sr-only">{{
                        `${t('WORK_TIME_CONTROLLING.VIOLATIONS.PLANNING_TITLE')} ${kinderOrt().getDisplayName()}`
                    }}
                </caption>
                <thead>
                <tr>
                    <th>{{ t('COMMON.NAME') }}</th>
                    <th>{{ t('COMMON.VORNAME') }}</th>
                    <th>{{ t('COMMON.GUELTIG_AB') }}</th>
                    <th>{{ t('COMMON.GUELTIG_BIS') }}</th>
                    <th>{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.TYPE') }}</th>
                    <th>{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.RULE_VALUE') }}</th>
                    <th>{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.VIOLATION_VALUE') }}</th>
                    <th>{{ t('COMMON.KINDERORT.SINGULAR') }}</th>
                </tr>
                </thead>
                <tbody>
                    @for (violation of violations(); track $index) {
                        <tr>
                            <td>{{ violation.angestellteFamilienName }}</td>
                            <td>{{ violation.angestellteVorName }}</td>
                            <td>{{ violation.gueltigAb | dvLocalDateFormat:undefined:true }}</td>
                            <td>{{ violation.gueltigBis | dvLocalDateFormat:undefined:true }}</td>
                            <td>{{ t('WORK_TIME_CONTROLLING.VIOLATIONS.TYPES.'+violation.type, {type: violation.type}) }}</td>
                            <td>{{ violation.ruleValue | dvMinutesFormat}}</td>
                            <td>{{ violation.violationValue | dvMinutesFormat}}</td>
                            <td>{{ violation.affectedKinderOrtNames?.join(', ') }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }

    <div class="text-center normal-abstand-top">
        <button type="button" class="btn btn-link" (click)="closeDialog.emit()">
            {{ t('COMMON.ABBRECHEN') }}
        </button>
    </div>
</ng-container>
